export function faqReturnToTop() {
	const faqBlock = document.querySelector('.farlo-ui-faq');
	const returnButton = document.querySelector('[data-farlo-ui-faq-return-top]');
	const header = document.querySelector('.site-header');

	if (!faqBlock || !returnButton) {
		return;
	}

	let blockTopPosition = null;

	// Calculate the top position of the FAQ block
	const updateBlockPosition = () => {
		blockTopPosition = faqBlock.getBoundingClientRect().top + window.scrollY;
	};

	// Get header height for offset calculation
	const getHeaderOffset = () => {
		if (!header) return 0;
		return header.offsetHeight || 0;
	};

	// Initialize position
	updateBlockPosition();

	// Update position on window resize
	window.addEventListener('resize', updateBlockPosition);

	// Show/hide button based on scroll position
	const handleScroll = () => {
		if (blockTopPosition === null) {
			updateBlockPosition();
		}

		const scrollPosition = window.scrollY;

		if (scrollPosition > blockTopPosition) {
			returnButton.hidden = false;
		} else {
			returnButton.hidden = true;
		}
	};

	// Handle button click
	const handleClick = () => {
		const headerOffset = getHeaderOffset();
		const targetPosition = faqBlock.getBoundingClientRect().top + window.scrollY - headerOffset;

		window.scrollTo({
			top: targetPosition,
			behavior: 'smooth'
		});
	};

	// Add event listeners
	window.addEventListener('scroll', handleScroll, { passive: true });
	returnButton.addEventListener('click', handleClick);

	// Initial check
	handleScroll();
}
